
import TextField from '@/components/general/atoms/TextField.vue';
import Modal from '@/components/general/molecules/Modal.vue';
import { defineComponent, ref } from 'vue';
import { AuthService } from '@/services/auth/AuthServices';


export default defineComponent({

    props: {
        visible: {
            type: Boolean,
            default: false,
            required: false
        }
    },

    emits: ["update:visible", "onClose"],
    
    setup() {

        const authServices = new AuthService();
        const errorMessage = ref("")
        const success = ref(false)
        const loadingResponse = ref(false);
        const email = ref("");

        async function handleForgorPassword() {
            loadingResponse.value = true;

            if(email.value == ''){
                loadingResponse.value = false;
                return;
            }
            try {
                await authServices.forgotPassword(email.value);
            }catch(e){
                console.log(e);
            }

            success.value = true;
            loadingResponse.value = false;
        }

        return {
            email,
            errorMessage,
            success,
            loadingResponse,
            handleForgorPassword

        };
    },
    components: { Modal, TextField }
})
